export default __webpack_public_path__ + "static/media/logo.ed5771de.svg";